module.exports = __webpack_public_path__ + "static/media/solutionIcon.d6481dc8.png";